import React from 'react'

import * as S from './ToggleAmountTypeInput.styles'
import { ToggleAmountTypeProps, ToggleInputTypes } from './ToggleAmountTypeInput.types'

const nextTypeBasedOnCurrentType: Record<number, ToggleInputTypes> = {
  [ToggleInputTypes.money]: ToggleInputTypes.percentage,
  [ToggleInputTypes.percentage]: ToggleInputTypes.money,
}

function ToggleAmountType({ type, small, onChange }: ToggleAmountTypeProps): JSX.Element {
  const handleNextType = () => {
    onChange(nextTypeBasedOnCurrentType[type])
  }

  return (
    <S.ToggleButtonContainer small={small} onClick={handleNextType}>
      <S.ToggleItem
        className={type === ToggleInputTypes.money ? 'active' : undefined}
        active={type === ToggleInputTypes.money}
        small={small}
        data-testid="money"
      >
        $
      </S.ToggleItem>

      <S.ToggleItem
        className={type === ToggleInputTypes.percentage ? 'active' : undefined}
        active={type === ToggleInputTypes.percentage}
        small={small}
        data-testid="percentage"
      >
        %
      </S.ToggleItem>
    </S.ToggleButtonContainer>
  )
}

export { ToggleAmountType }
